import React, { Component } from "react";
import {
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  InputGroup,
  Row,
  Col,
} from "reactstrap";
import Draggable from "react-draggable";
import { RepForm } from "./RepForm";
import { RepFormSearchTableDefault } from "./RepFormSearchTableDefault";

import { FetchData } from "./utils/DataFetch";
import { GetCookie } from "./utils/Common";

import AddIcon from "../images/add.png";

export class RepFormSearch extends Component {
  static displayName = RepFormSearch.name;

  constructor(props) {
    super(props);

    this.user = JSON.parse(GetCookie("user"));
    this.state = {
      repList: [],
      searchModel: {
        RepName: props.RepName === null ? "" : props.RepName,
        ClientAbbrv: props.ClientAbbrv ?? "",
      },
      deltaPosition: { x: 0, y: 0 },
      modalRepForm: false,
      model: this.getInitialModel(),
    };

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.populateRepData = this.populateRepData.bind(this);
    this.renderRepTable = this.renderRepTable.bind(this);
    this.setModalRepForm = this.setModalRepForm.bind(this);
    this.handleRepSaveEventSuccess = this.handleRepSaveEventSuccess.bind(this);

    if ((props.RepName !== null && props.RepName !== "") || props.ClientAbbrv) this.populateRepData();

    this.repSearchRef = React.createRef();
  }

  componentDidMount() {
    this.setState({ isMounted: true }); // Set isMounted to true when the component mounts

    document.addEventListener("keydown", this.keydownHandler);

    // Set focus to the rep name field
    setTimeout(() => {
      if (this.repSearchRef.current) {
        this.repSearchRef.current.focus();
      }
    }, 100);

    return () => {
      document.removeEventListener("keydown", this.keydownHandler);
    };
  }

  onStart = () => {};

  onStop = () => {};

  handleDrag = (e, ui) => {
    const { deltaPosition } = this.state;
    this.setState({
      deltaPosition: {
        x: deltaPosition.x + ui.deltaX,
        y: deltaPosition.y + ui.deltaY,
      },
    });
  };

  getInitialModel() {
    const client = this.props.client || {};
    return {
      EventType: "insert",
      RepId: null,
      // RepForm only prompts for a Client when ClientId is null, and work orders store "no client" as "".
      ClientId: client.ClientId || null,
      RepLastName: "",
      RepFirstName: "",
      RepPhone: "",
      RepPhone2: "",
      RepNote: "",
      RepZip: "",
      RepEmail: "",
      RepInactiveFlg: false,
      CreateDateTime: null,
      CreatebyUserId: null,
      UpdateByUserId: null,
      UpdateDateTime: null,
      IsDeletedFlg: false,
      ClientName: client.ClientName ?? "",
      ClientAbbrv: client.ClientAbbrv ?? "",
      ClientPhone: client.ClientPhone ?? "",
      ClientPhone2: "",
      ClientEmail: client.ClientEmail ?? "",
    };
  }

  setModalRepForm() {
    this.setState((prevState) => ({
      modalRepForm: !prevState.modalRepForm,
      ...(!prevState.modalRepForm && { model: this.getInitialModel() }),
    }));
  }

  // saverep doesn't return the new RepId, so search for the saved rep to let the user pick it.
  handleRepSaveEventSuccess(alert) {
    this.setState(
      {
        modalRepForm: alert.modal,
        ...(alert.model && {
          searchModel: {
            RepName: alert.model.RepLastName,
            ClientAbbrv: alert.model.ClientAbbrv ?? "",
          },
        }),
      },
      () => {
        if (alert.model) this.populateRepData();
      }
    );
  }

  handleChange(e) {
    let model = { ...this.state.searchModel };
    model[e.target.name] = e.target.value;

    this.setState({ searchModel: model });
  }

  handleKeyDown(e) {
    if (e.key === "Enter") {
      this.populateRepData();
    }
  }

  async populateRepData() {
    this.props.setFetchingData?.(true);
    await FetchData(
      "/getreps",
      "POST",
      this.user.token,
      this.state.searchModel
    ).then((data) => {
      this.setState({ repList: data });
      this.props.setFetchingData?.(false);
    });
  }

  renderRepTable(repList) {
    return (
      <RepFormSearchTableDefault
        repList={repList}
        handleDoubleClick={this.props.handleDoubleClick}
      ></RepFormSearchTableDefault>
    );
  }

  render() {
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    const { deltaPosition } = this.state;

    return (
      <Draggable
        handle=".rep-form-search-handle"
        onDrag={this.handleDrag}
        {...dragHandlers}
      >
        <div>
          <Modal
            isOpen={this.props.modal}
            toggle={this.props.setModal}
            style={{
              transform: `translate(${deltaPosition.x}px, ${deltaPosition.y}px)`,
              width: "1000px",
              maxHeight: "500px",
            }}
            backdrop="static"
          >
            <ModalHeader className="rep-form-search-handle handle">
              <span style={{ fontSize: "14px" }}>Search Rep</span>
            </ModalHeader>
            <ModalBody>
              <div>
                <Row>
                  <Col>
                    <InputGroup size="sm">
                      <input
                        name="RepName"
                        type="text"
                        className="form-control form-control-text"
                        value={this.state.searchModel.RepName}
                        onChange={this.handleChange}
                        ref={this.repSearchRef}
                        placeholder="Search Rep Name (Lastname, Firstname)"
                        onKeyDown={this.handleKeyDown}
                      />
                      <input
                        name="ClientAbbrv"
                        type="text"
                        className="form-control form-control-text"
                        value={this.state.searchModel.ClientAbbrv}
                        onChange={this.handleChange}
                        placeholder="Client Abbrv"
                        onKeyDown={this.handleKeyDown}
                      />
                      {this.props.allowNew && (
                        <Button
                          color="btn"
                          size="sm"
                          onClick={this.setModalRepForm}
                        >
                          <img
                            src={AddIcon}
                            style={{ width: "16px", height: "16px" }}
                            alt="Add"
                          />{" "}
                          New
                        </Button>
                      )}
                    </InputGroup>
                  </Col>
                </Row>
                <Row>
                  <Col
                    className=" x-panel-body x-layout-fit x-panel-body-default"
                    style={{
                      overflowY: "scroll",
                      height: "450px",
                      backgroundColor: "unset",
                      width: "100%",
                      marginLeft: "8px",
                      marginRight: "10px",
                    }}
                  >
                    {this.renderRepTable(this.state.repList)}
                  </Col>
                </Row>
              </div>
            </ModalBody>
          </Modal>

          {this.state.modalRepForm && (
            <RepForm
              model={this.state.model}
              modal={this.state.modalRepForm}
              alert={this.props.alert}
              setModal={this.setModalRepForm}
              handleSaveEventSuccess={this.handleRepSaveEventSuccess}
              setFetchingData={this.props.setFetchingData}
            />
          )}
        </div>
      </Draggable>
    );
  }
}
